import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { Fieldset } from 'primereact/fieldset';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import {
    deleteProduct,
    getAllProducts,
    getProductDetail,
    saveProduct
} from "../../redux/actions/products_actions";

const AdminProduct = (props) => {      
    // Get Data       
    useEffect(() => { 
        props.dispatch(getAllProducts())
    }, []);

    const[globalFilter, setGlobalFilter] = useState("");
    const[loading, setLoading] = useState(false);
    const[displayModal, setDisplayDialog] = useState(false);
    const[displayModalDelete, setDisplayDialogDelete] = useState(false);
    const[productId, setProductId] = useState(0);
    const[dialogHeader, setHeader] = useState("");
    const[display, setDisplay] = useState("block");
    const[productDetail, setProductDetail] = useState({});
    const toast = useRef(null);

    const categorySelectItems = [
        {label: 'Sofa', value: 1},
        {label: 'Bàn', value: 2},
        {label: 'Ghế', value: 3},
        {label: 'Giường', value: 5}
    ];

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'VND' });
    }
    
    const priceTemplate = (data) => {
        return formatCurrency(data.price);
    }
    
    const imageTemplate = (data) => {
        if (data.image) {
            return <img src={data.image} className="product-image" />;
        }
    }

    const onChangeText = (name, e) => {
        setProductDetail((preState) => ({
            ...preState,
            [`${name}`]: e
        }));
    }

    const onChangeDropdown = (e) => {
        setProductDetail((preState) => ({
            ...preState,
            categoryId: e
        }));
    }

    const showToast = (type, detail, life) => {
        if (!life) {
            life = 3000;
        }
        toast.current.show({
            severity: type, 
            summary: "Thông báo", 
            detail: detail, 
            life: life
        });
    }

    const openDialog = (id) => {
        if (id) {
            props.dispatch(getProductDetail(id, "")).then(res => {
                if (res.payload.product != undefined) {
                    setProductDetail(res.payload.product);
                    setHeader("Chi tiết sản phẩm #" + res.payload.product.productId);
                    setDisplay("block");
                    setDisplayDialog(true);
                }
            })
        }
        else {
            setProductDetail({});
            setHeader("Thêm mới sản phẩm");
            setDisplay("none");
            setDisplayDialog(true);
        }
    }

    const openDialogDelete = (id) => {
        setProductId(id);
        setDisplayDialogDelete(true);
    }

    const closeDialog = () => {
        setDisplayDialog(false);
        setDisplayDialogDelete(false);
    }

    const buttonTemplate = (data) => {
        return (
            <span>
                <Button icon="pi pi-user-edit" 
                    className="p-button-rounded p-button-secondary p-button-outlined"
                    onClick={(e) => openDialog(data.productId)}
                 />
                <Button icon="pi pi-trash" 
                    style={{marginLeft: '10px'}} 
                    className="p-button-rounded p-button-danger p-button-outlined" 
                    onClick={(e) => openDialogDelete(data.productId)}
                />
            </span>
        );
    }

    const saveDialog = () => {
        // console.log(productDetail);
        if (productDetail && 
            productDetail.productName && productDetail.productName != "" && 
            productDetail.categoryId && 
            productDetail.price) {
            //save data
            props.dispatch(saveProduct(productDetail, "")).then(res => {
                if (res.payload != undefined) {
                    closeDialog();
                    props.dispatch(getAllProducts());
                    if(res.payload.result.success) {
                        showToast("success", "Lưu sản phẩm thành công!");
                    }
                    else {
                        // console.log(res.payload.result.message);
                        showToast("error", "Đã có lỗi xảy ra trong quá trình lưu sản phẩm. Vui lòng thử lại sau!");
                    }
                }
            });
        }
        else {
            showToast("warn", "Vui lòng nhập đầy đủ các thông tin đánh dấu (*)", 4000);
        }
    }

    const handleDeleteProduct = (id) => {
        props.dispatch(deleteProduct(id, "")).then(res => {
            if (res.payload != undefined) {
                closeDialog();
                props.dispatch(getAllProducts());
                if(res.payload.result.success) {
                    showToast("success", "Xóa sản phẩm thành công!");
                }
                else {
                    // console.log(res.payload.result.message);
                    showToast("error", "Đã có lỗi xảy ra trong quá trình xóa sản phẩm. Vui lòng thử lại sau!");
                }
            }
        });
    }

    const renderFooter = () => {
        return (
            <div>
                <Button label="Lưu" className="p-button p-button-outlined p-button-success" icon="pi pi-check" onClick={saveDialog} autoFocus />
            </div>
        );
    }

    const renderFooterDelete = (id) => {
        return (
            <div>
                <Button label="Không" className="p-button p-button-outlined p-button-danger" icon="pi pi-times" onClick={closeDialog} />
                <Button label="Có" style={{marginLeft: '10px'}} className="p-button p-button-outlined p-button-success" icon="pi pi-check" onClick={(e) => handleDeleteProduct(id)} autoFocus />
            </div>
        );
    }

    // props.<combine>.<reducer>.<action>.<properties>
    // console.log(props.products.product);
    if(props.products.product != undefined) {
        let columns = [
            { field : 'productId', header: 'Mã' },
            { field : 'productName', header: 'Tên sản phẩm' },
            { field : 'categoryName', header: 'Danh mục' },
            { field : 'image', header: 'Hình ảnh' },
            { field : 'stock', header: 'Tồn kho' },
            { field : 'price', header: 'Đơn giá' },
            { field : 'actions', header: 'Thao tác' },
        ]

        const dynamicColumns = columns.map((col,i) => {
            let className_align = "";
            if (col.field == "price" || col.field == "stock") {
                className_align = "text-right";
            }
            else if (col.field == "productId" || col.field == "image" || col.field == "actions") {
                className_align = "text-center";
            }

            if (col.field == "price") {
                return <Column key={col.field} 
                            field={col.field} 
                            header={col.header} 
                            body={priceTemplate} 
                            className={className_align} 
                            sortable
                        />;
            }
            else if (col.field == "image") {
                return <Column key={col.field} 
                            field={col.field} 
                            header={col.header} 
                            body={imageTemplate} 
                            className={`${className_align} product-img-list`}
                        />;
            }
            else if (col.field == "actions") {
                return <Column key={col.field} 
                            field={col.field} 
                            header={col.header} 
                            body={buttonTemplate}
                            className={className_align}
                        />;
            }
            else {
                return <Column key={col.field} field={col.field} header={col.header} className={className_align} sortable />;
            }
        });

        const header = (
            <div className="table-header" >
                <div style={{float: "left"}}>
                    <Button label="Thêm" 
                        icon="pi pi-plus-circle" 
                        className="p-button p-button-outlined p-button-primary"
                        onClick={(e) =>  openDialog()}     
                    />
                    <Button label="Nhập" icon="pi pi-download" style={{marginLeft: '10px'}} 
                        className="p-button p-button-outlined p-button-success"
                     />
                    <Button label="Xuất" icon="pi pi-upload" style={{marginLeft: '10px'}} 
                        className="p-button p-button-outlined p-button-help" />
                </div>
                <div style={{textAlign: "right"}}>
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Tìm kiếm" />
                    </span>
                </div>
            </div>
        );

        return (
            <>
                <div className="admin-margin">
                    <Fieldset legend="Quản lý sản phẩm">
                        <DataTable value={props.products.product.products} 
                            className="dt-style"
                            header={header}
                            globalFilter={globalFilter} emptyMessage="No record found." loading={loading}
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Hiển thị từ {first} đến {last} trên tổng số {totalRecords} mục" rows={10} rowsPerPageOptions={[10,20,50]}
                        >
                            {dynamicColumns}
                        </DataTable>
                    </Fieldset>
                </div>

                <Dialog className="product-dialog" 
                    modal
                    header={dialogHeader} 
                    footer={renderFooter()} 
                    visible={displayModal} 
                    onHide={closeDialog}
                >
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12">
                            <label>Tên sản phẩm</label>
                            <span className="required-icon">*</span>
                            <InputText id="productName" type="text" value={productDetail.productName} onChange={(e) => onChangeText("productName", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Loại sản phẩm</label>
                            <span className="required-icon">*</span>
                            <Dropdown inputId="state" value={productDetail.categoryId} options={categorySelectItems} onChange={(e) => onChangeDropdown(e.target.value)} placeholder="-- Vui lòng chọn --" />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Màu sắc</label>
                            <InputText id="color" type="text" value={productDetail.color} onChange={(e) => onChangeText("color", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Chất liệu</label>
                            <InputText id="material" type="text" value={productDetail.material} onChange={(e) => onChangeText("material", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Chiều dài</label>
                            <InputText id="length" type="number" value={productDetail.length} onChange={(e) => onChangeText("length", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Chiều rộng</label>
                            <InputText id="width" type="number" value={productDetail.width} onChange={(e) => onChangeText("width", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Chiều cao</label>
                            <InputText id="height" type="number" value={productDetail.height} onChange={(e) => onChangeText("height", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4">
                            <label>Đơn giá</label>
                            <span className="required-icon">*</span>
                            <InputText id="price" type="number" value={productDetail.price} onChange={(e) => onChangeText("price", e.target.value)} />
                        </div>
                        <div className="p-field p-col-4" style={{ display: display }}>
                            <label>Tồn kho</label>
                            <InputText id="stock" type="number" value={productDetail.stock} onChange={(e) => onChangeText("stock", e.target.value)} disabled="disabled" />
                        </div>
                        <div className="p-field p-col-12">
                            <label>Đường dẫn hình ảnh</label>
                            <InputText id="image" type="text" value={productDetail.image} onChange={(e) => onChangeText("image", e.target.value)} />
                        </div>
                        <div className="p-field p-col-12">
                            <label>Ghi chú</label>
                            <InputTextarea id="notes" type="text" rows="2" value={productDetail.notes} onChange={(e) => onChangeText("notes", e.target.value)} />
                        </div>
                    </div>
                </Dialog>

                <Dialog className="delete-dialog" 
                    modal 
                    header="Xác nhận xóa" 
                    footer={renderFooterDelete(productId)}
                    visible={displayModalDelete} 
                    onHide={closeDialog}
                >
                    <div className="confirmation-content text-center">
                        <i className="pi pi-exclamation-triangle p-mr-3"/>
                        <span>Bạn có chắc chắn muốn xóa sản phẩm #{productId}?</span>
                    </div>
                </Dialog>

                <Toast ref={toast} />
            </>
        );
    }
    else {
        return (
            <>
                <div>
                    <p>Loading</p>
                </div>
            </>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        products: state.products,
    };
};

export default connect(mapStateToProps)(AdminProduct);
